/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuestionnaireQuestionResponseCurrentAnswer } from './questionnaire-question-response-current-answer';
import { AnswerTypeEnum } from './answer-type-enum';
import { QuestionnaireType } from './questionnaire-type';
import { QuestionnaireAnswer } from './questionnaire-answer';

export interface QuestionnaireQuestionResponse {
  readonly id: string;
  readonly question: string;
  readonly help: string | null;
  readonly number: number;
  readonly answer_type: AnswerTypeEnum;
  readonly page_number: number;
  readonly answers: Array<QuestionnaireAnswer> | null;
  readonly optional: boolean;
  readonly condition: { [key: string]: Array<string> };
  /**
   * Minimal length of answer.
   */
  readonly min_length: number;
  /**
   * Maximal length of answer. Set 0 for unlimited.
   */
  readonly max_length: number;
  readonly error_message: string | null;
  readonly questionnaire_type: QuestionnaireType;
  current_answer: QuestionnaireQuestionResponseCurrentAnswer;
}
export namespace QuestionnaireQuestionResponse {}
